import { Switch } from "@/components/ui/switch";

interface ConsentToggleProps {
  title: string;
  description: string;
  checked: boolean;
  onCheckedChange: () => void;
}

export function ConsentToggle({ title, description, checked, onCheckedChange }: ConsentToggleProps) {
  return (
    <div className="flex items-center justify-between space-x-2 py-2">
      <div className="space-y-0.5 flex-1">
        <h4 className="text-sm font-medium sm:text-base">{title}</h4>
        <p className="text-xs sm:text-sm text-muted-foreground">
          {description}
        </p>
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="ml-2"
      />
    </div>
  );
}